import React, { useEffect } from 'react';
import styled from 'styled-components';

const SnackbarContainer = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${props => props.tipo === 'error' ? '#D32F2F' : props.tipo === 'warning' ? '#F57C00' : '#388E3C'};
  color: white;
  padding: 14px 24px;
  border-radius: 4px;
  box-shadow: 0 3px 5px -1px rgba(0,0,0,0.2), 0 6px 10px 0 rgba(0,0,0,0.14), 0 1px 18px 0 rgba(0,0,0,0.12);
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  z-index: 9999;
  min-width: 288px;
  max-width: 568px;
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from {
      bottom: 0;
      opacity: 0;
    }
    to {
      bottom: 24px;
      opacity: 1;
    }
  }
`;

const Message = styled.div`
  flex: 1;
  line-height: 1.4;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0;
  font-size: 20px;
  line-height: 1;
  opacity: 0.7;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
`;

const Snackbar = ({ mensagem, tipo = 'success', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onClose) onClose();
    }, 4000);

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!mensagem) return null;

  return (
    <SnackbarContainer tipo={tipo}>
      <Message>{mensagem}</Message>
      <CloseButton onClick={onClose}>×</CloseButton>
    </SnackbarContainer>
  );
};

export default Snackbar;
